import colors from '../../util/colors.js';

// for definition HEX, only long entry, for example #ffffff, #FFFFFF is correct, #fff, #FFF is not correct.
var matchHexColor = /^#[0-9a-f]{6}$/i;
// for definition RGB, only with one break, for example rgb(013, 100, 120), rgb(13, 100, 120) is correct, rgb(13,100, 120), rgb(13, 100,  120) is not correct.
var matchRGBColor = /^rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)$/;
// for definition RGBA, only with one break, for example rgba(013, 100, 120, 0.8), rgb(13, 100, 120, .8) is correct, rgb(13,100, 120, 0.8), rgb(13, 100,  120, .8) is not correct.
var matchRGBAColor = /^rgba\((\d{1,3}), (\d{1,3}), (\d{1,3}), (\d*(?:\.\d+)?)\)$/;
// pass the saturation value of a specific of the three primary colors and the second argument to the alpha channel is similar to rgba
// adds saturation to this color by the specified value, which when added to all three values brings it closer to white
// for example highlighten(0, 0.3) will return 179 and that is 70% of 255
var highlighten = function (saturation, alpha) {
    var diffFromWhite = 255 - saturation;
    var highlightCount = alpha < 1 ? 1 - alpha : 0;
    var additionSaturation = Math.round(diffFromWhite * highlightCount);
    return saturation + additionSaturation;
};
// format hex to rgb array for example hexToRGBArray('#646464'); will return [100, 100, 100]
var hexToRGBArray = function (color) {
    var convert = function (from) { return parseInt(color.slice(from, from + 2), 16); };
    return [1, 3, 5].reduce(function (acc, from) {
        acc.push(convert(from));
        return acc;
    }, []);
};
// format rgb to rgb array for example rgbToRGBArray('rgb(100, 100, 100)'); will return [100, 100, 100]
var rgbToRGBArray = function (color) {
    var convert = (matchRGBColor.exec(color) || []).map(function (item) { return +item; });
    return convert.slice(1, 4);
};
// format rgba to lighten rgb array for example rgbaToRGBArray('rgba(100, 100, 100, 0.3)'); will return [209, 209, 209]
var rgbaToRGBArray = function (color) {
    var match = matchRGBAColor.exec(color) || [];
    var alpha = +match[4];
    var colors = match.slice(1, 4);
    return colors.map(function (item) { return highlighten(+item, alpha); });
};
// checks the format of notation of color, formats and returns an rgb array for example
// stringToRGBArray('#646464'); will return [100, 100, 100] and stringToRGBArray('rgb(100, 100, 100)'); will return [100, 100, 100] too
// if the string does not pass the check it will return [229, 231, 236], which is formatted colors.base20
var stringToRGBArray = function (color) {
    var lowerColorString = color.toLowerCase();
    var isHEX = matchHexColor.test(lowerColorString);
    var isRGB = matchRGBColor.test(lowerColorString);
    var isRGBA = matchRGBAColor.test(lowerColorString);
    var isCorrectColor = isHEX || isRGB || isRGBA;
    if (!isCorrectColor) {
        lowerColorString = colors.base20;
        console.warn('Color is incorrect');
    }
    switch (true) {
        case matchHexColor.test(lowerColorString):
            return hexToRGBArray(lowerColorString);
        case matchRGBColor.test(lowerColorString):
            return rgbToRGBArray(lowerColorString);
        case matchRGBAColor.test(lowerColorString):
            return rgbaToRGBArray(lowerColorString);
        default:
            return [];
    }
};
// format hex to rgb array for example rgbArrayToHex([100, 100, 100]); will return '#646464'
var rgbArrayToHex = function (rgbArray) {
    return rgbArray.reduce(function (acc, item) { return "" + acc + item.toString(16); }, '#');
};
// convert one color to object with baseColor and highlightColor (30% highlighting)
// for example convertColor(colors.base20) will retutn {baseColor: '#e5e7ec', highlightColor: '#f7f8f9'}
var convertColor = function (color, changedColor, highlightenColor) {
    if (color === void 0) { color = colors.base20; }
    var rgbArray = stringToRGBArray(color);
    var isCorrectColor = rgbArray.filter(function (item) { return item <= 255; }).length === 3;
    if (!isCorrectColor) {
        console.warn('Color is incorrect');
        rgbArray = stringToRGBArray(colors.base20);
    }
    var highlightedRgb = rgbArray.map(function (saturation) {
        return highlighten(saturation, 0.3);
    });
    var baseColor = changedColor || rgbArrayToHex(rgbArray);
    var highlightColor = highlightenColor || rgbArrayToHex(highlightedRgb);
    return { baseColor: baseColor, highlightColor: highlightColor };
};
// convert properties and custom styles to element styles
var getItemStyles = function (stylesProperties) {
    var _a;
    var direction = stylesProperties.direction, duration = stylesProperties.duration, enableAnimation = stylesProperties.enableAnimation, _b = stylesProperties.style, style = _b === void 0 ? {} : _b, color = stylesProperties.color;
    var base20 = colors.base20, highlightBase20 = colors.highlightBase20;
    var baseColor = stylesProperties.baseColor, highlightColor = stylesProperties.highlightColor;
    if (color !== base20 && (!highlightColor || !baseColor)) {
        (_a = convertColor(color, baseColor, highlightColor), baseColor = _a.baseColor, highlightColor = _a.highlightColor);
    }
    var isNewBase = baseColor !== base20;
    var isNewHighlight = highlightColor !== highlightBase20;
    return Object.assign(style, isNewBase && { '--base-color': baseColor }, isNewHighlight && { '--highlight-color': highlightColor }, duration && { '--animation-duration': duration + "s" }, direction === 'rtl' && { '--animation-direction': 'reverse' }, !enableAnimation && { '--pseudo-element-display': 'none' });
};
// returns the primitive value of now
var getTimeId = function () { return new Date().valueOf(); };
// creates a unique key, concatenates the index of the element in the array and the primitive value of now
var getItemKey = function (i) {
    return "skeleton-item-" + i + "-" + getTimeId();
};

export { convertColor, getItemKey, getItemStyles, getTimeId, hexToRGBArray, highlighten, matchHexColor, matchRGBAColor, matchRGBColor, rgbArrayToHex, rgbToRGBArray, rgbaToRGBArray, stringToRGBArray };
